import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { ApiError, authApi } from '@/api/client'
import type { AdminProfile, LoginRequest } from '@/api/types'

export const useAuthStore = defineStore('auth', () => {
  const admin = ref<AdminProfile | null>(null)
  const initialized = ref(false)
  const isAuthenticated = computed(() => admin.value !== null)

  function clear(): void {
    admin.value = null
  }

  async function restore(): Promise<void> {
    try {
      admin.value = await authApi.me()
    } catch (error) {
      if (!(error instanceof ApiError) || error.status !== 401) {
        throw error
      }
      clear()
    }
    initialized.value = true
  }

  async function login(payload: LoginRequest): Promise<void> {
    admin.value = await authApi.login(payload)
  }

  async function logout(): Promise<void> {
    await authApi.logout()
    clear()
  }

  return { admin, initialized, isAuthenticated, clear, restore, login, logout }
})
